'use strict'

// Normalizes the SEO performance API payload into a flat array of per-page
// metric rows. The backend may return page-level data under several key names
// as the integration evolves; this function resolves them in priority order.
//
// Each normalized row has the shape:
//   { url, path, health, score, clicks, impressions, ctr, position }
// All fields default to null when absent so the template can use ?? '--'.
//
// AC011 (local-analyzer story): LocalSeoAnalyzer emits `page_metrics` rows
// in the shape { url, path, score, status, issues }. The existing key
// resolution chain (payload.page_metrics → payload.pages → nested
// performance.* mirrors) handles this shape unchanged — `score` and `url`
// are already first-class. Test coverage: seo-local-analyzer-contract.test.js.

export function normalizeSeoPageMetrics(payload) {
  if (!payload) return []

  // Candidate arrays in priority order
  const raw =
    (Array.isArray(payload.page_metrics) && payload.page_metrics) ||
    (Array.isArray(payload.pages) && payload.pages) ||
    (payload.performance && Array.isArray(payload.performance.page_metrics) && payload.performance.page_metrics) ||
    (payload.performance && Array.isArray(payload.performance.pages) && payload.performance.pages) ||
    []

  return raw.map((row) => ({
    url:         row.url         ?? row.page_url  ?? null,
    path:        row.path        ?? row.page_path ?? extractPath(row.url ?? row.page_url),
    health:      row.health      ?? null,
    score:       row.score       ?? row.page_speed_score ?? null,
    clicks:      row.clicks      ?? row.total_clicks      ?? null,
    impressions: row.impressions ?? row.total_impressions ?? null,
    ctr:         row.ctr         ?? row.average_ctr       ?? null,
    position:    row.position    ?? row.average_position  ?? null,
  }))
}

function extractPath(url) {
  if (!url) return null
  try {
    return new URL(url).pathname
  } catch {
    return url
  }
}
